import React from 'react';
import { Typography } from '@mui/material';

const ReportTitle = ({ children }) => {
  return (
    <Typography 
      variant="h4" 
      component="h1" 
      sx={{
        fontWeight: 'bold',
        color: 'primary.main',
        fontSize: '1.75rem',
        lineHeight: 1.2,
        marginBottom: 2
      }}
    >
      {children}
    </Typography>
  );
};

export default ReportTitle; 